import { createContext, useContext } from 'react'
import type { AppModule } from './registry'

const CurrentModuleContext = createContext<AppModule | null>(null)

export const CurrentModuleProvider = CurrentModuleContext.Provider

/** Returns the current module definition, or null outside a module route. */
export function useCurrentModule(): AppModule | null {
  return useContext(CurrentModuleContext)
}
